export default __webpack_public_path__ + "static/media/slide_1.9fd23330.jpg";